class QuantityRocker extends HTMLElement {
  static formAssociated = true;
  #shadow = null;
  #shadowDecement = null;
  #shadowInput = null;
  #shadowIncrement = null;

  constructor() {
    super();
  }
  connectedCallback() {
    this.#shadow = this.attachShadow({ mode: "open" });
    this.internals = this.attachInternals();
    this.render();
  }
  render() {
    if (!this.#shadow) {
      return;
    }
    this.#shadow.innerHTML = `
      <style>
        input::-webkit-outer-spin-button,input::-webkit-inner-spin-button {-webkit-appearance: none; margin: 0;}
        input:focus{outline: none;}
      </style>
      <div part="wrapper">
          <button part="decrement" ${this.value="=" this.min="" ?="" "disabled"="" :="" ""}="">-</button>
          <input part="input" type="number" aria-label="quantity" value="${this.value}" min="${this.min}" max="${this.max}">
          <button part="increment" ${this.value="=" this.max="" ?="" "disabled"="" :="" ""}="">+</button>
      </div>
    `;
    this.#shadowDecement = this.#shadow.querySelector('[part="decrement"]');
    this.#shadowDecement.addEventListener("click", () => {
      this.value = this.value - 1;
      this.update();
    });
    this.#shadowInput = this.#shadow.querySelector('[part="input"]');
    this.#shadowInput.addEventListener("change", () => {
      this.value = Number(this.#shadowInput.value);
      this.update();
    });
    this.#shadowIncrement = this.#shadow.querySelector('[part="increment"]');
    this.#shadowIncrement.addEventListener("click", () => {
      this.value = this.value + 1;
      this.update();
    });
  }
  update() {
    this.dispatchEvent(new Event("change"));
    this.render();
  }
  set value(v) {
    const clampedValue = Math.max(this.min, Math.min(this.max, Number(v)));
    this.setAttribute("value", clampedValue);
    this.internals?.setFormValue(clampedValue);
  }
  get value() {
    return Number(this.getAttribute("value"));
  }
  set min(v) {
    this.setAttribute("min", v);
  }
  get min() {
    return Number(this.getAttribute("min") || 0);
  }
  set max(v) {
    this.setAttribute("max", v);
  }
  get max() {
    return Number(this.getAttribute("max") || 999);
  }
  get form() {
    return this.internals.form;
  }
  get type() {
    return this.localName;
  }

  static get observedAttributes() {
    return ["value", "id", "min", "max"];
  }
  attributeChangedCallback(property, oldValue, newValue) {
    if (oldValue === newValue) return;
    this[property] = newValue;
    this.render();
  }
}
customElements.define("quantity-rocker", QuantityRocker);
